var map = {
	"./en_ID.json": 799,
	"./en_MM.json": 800,
	"./en_MY.json": 801,
	"./en_PH.json": 802,
	"./en_SG.json": 803,
	"./en_TH.json": 804,
	"./en_VN.json": 805,
	"./fr_MA.json": 1264,
	"./id_ID.json": 1265,
	"./th_TH.json": 1266,
	"./vi_VN.json": 1267,
	"./zh_CN.json": 1268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2600;